export const ShopMonitorNumber = "3333333333";